var _path, _path2, _path3, _path4, _path5, _path6, _path7, _filter;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMicrosoftExcel = function SvgMicrosoftExcel(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 128 128",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.08,
    d: "M27 96.667V31.333C27 19.083 31.111 15 43.444 15h24.667L101 47.667v49C101 108.917 96.889 113 84.555 113h-41.11C31.11 113 27 108.917 27 96.667",
    style: {
      fill: "#000",
      fillOpacity: 0.08
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#svg_icon_MicrosoftExcel__filter0_dd_2256_17069)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M28 96V32c0-12 4-16 16-16h24l32 32v48c0 12-4 16-16 16H44c-12 0-16-4-16-16",
    style: _defineProperty(_defineProperty({
      fill: "#fefefe"
    }, "fill", "color(display-p3 .9961 .9961 .9961)"), "fillOpacity", 1)
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_MicrosoftExcel__paint0_linear_2256_17069)",
    fillOpacity: 0.16,
    d: "M28 96V32c0-12 4-16 16-16h24l32 32v48c0 12-4 16-16 16H44c-12 0-16-4-16-16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_MicrosoftExcel__paint1_linear_2256_17069)",
    fillOpacity: 0.08,
    d: "M28 96V32c0-12 4-16 16-16h24l32 32v48c0 12-4 16-16 16H44c-12 0-16-4-16-16"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_MicrosoftExcel__paint2_radial_2256_17069)",
    fillOpacity: 0.2,
    d: "M28 96V32c0-12 4-16 16-16h24l32 32v48c0 12-4 16-16 16H44c-12 0-16-4-16-16"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_MicrosoftExcel__paint3_radial_2256_17069)",
    fillOpacity: 0.4,
    d: "M28 96V32c0-12 4-16 16-16h24l32 32v48c0 12-4 16-16 16H44c-12 0-16-4-16-16"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_MicrosoftExcel__paint4_radial_2256_17069)",
    fillOpacity: 0.8,
    d: "M28 96V32c0-12 4-16 16-16h24l32 32v48c0 12-4 16-16 16H44c-12 0-16-4-16-16"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#185C37",
    d: "m69.116 78.675-15.814-2.791v20.62c0 .942.764 1.705 1.705 1.705h27.288c.942 0 1.705-.763 1.705-1.705v-7.597z",
    style: _defineProperty(_defineProperty({
      fill: "#185c37"
    }, "fill", "color(display-p3 .0941 .3608 .2157)"), "fillOpacity", 1)
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21A366",
    d: "M69.116 61H55.007c-.941 0-1.705.763-1.705 1.705v7.597l15.814 9.303 8.372 2.79L84 79.605v-9.303z",
    style: _defineProperty(_defineProperty({
      fill: "#21a366"
    }, "fill", "color(display-p3 .1294 .6392 .4)"), "fillOpacity", 1)
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#107C41",
    d: "M53.302 70.302h15.814v9.303H53.302z",
    style: _defineProperty(_defineProperty({
      fill: "#107c41"
    }, "fill", "color(display-p3 .0627 .4863 .2549)"), "fillOpacity", 1)
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M64.62 68.442H53.303v23.256h11.319a1.71 1.71 0 0 0 1.705-1.705V70.147a1.71 1.71 0 0 0-1.705-1.705",
    opacity: 0.1,
    style: {
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M63.69 69.372H53.302v23.256H63.69a1.71 1.71 0 0 0 1.705-1.705V71.077a1.71 1.71 0 0 0-1.705-1.705",
    opacity: 0.2,
    style: {
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M63.69 69.372H53.302v21.395H63.69a1.71 1.71 0 0 0 1.705-1.705V71.077a1.71 1.71 0 0 0-1.705-1.705",
    opacity: 0.2,
    style: {
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M62.76 69.372h-9.458v21.395h9.458a1.71 1.71 0 0 0 1.705-1.705V71.077a1.71 1.71 0 0 0-1.705-1.705",
    opacity: 0.2,
    style: {
      fill: "#000",
      fillOpacity: 1
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_MicrosoftExcel__paint5_linear_2256_17069)",
    d: "M45.705 69.372H62.76c.942 0 1.705.763 1.705 1.705v17.055c0 .942-.763 1.705-1.705 1.705H45.705A1.705 1.705 0 0 1 44 88.132V71.077c0-.942.763-1.705 1.705-1.705"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m49.28 85.147 3.588-5.558-3.287-5.528h2.644l1.794 3.535q.248.503.34.75h.023q.174-.396.372-.78l1.918-3.503h2.427l-3.37 5.495 3.455 5.589h-2.582l-2.072-3.88a3.3 3.3 0 0 1-.247-.518h-.03q-.093.264-.24.502l-2.134 3.896z",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33C481",
    d: "M82.295 61H69.116v9.302H84v-7.597c0-.942-.763-1.705-1.705-1.705",
    style: _defineProperty(_defineProperty({
      fill: "#33c481"
    }, "fill", "color(display-p3 .2 .7686 .5059)"), "fillOpacity", 1)
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#107C41",
    d: "M69.116 79.605H84v9.302H69.116z",
    style: _defineProperty(_defineProperty({
      fill: "#107c41"
    }, "fill", "color(display-p3 .0627 .4863 .2549)"), "fillOpacity", 1)
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M68 16s23.054 23.074 32 32H84c-12 0-16-4-16-16z",
    style: _defineProperty(_defineProperty({
      fill: "#fefefe"
    }, "fill", "color(display-p3 .9948 .9948 .9948)"), "fillOpacity", 1)
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_MicrosoftExcel__paint6_linear_2256_17069)",
    fillOpacity: 0.12,
    d: "M68 16s23.054 23.074 32 32H84c-12 0-16-4-16-16z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.08,
    d: "M68 16s23.054 23.074 32 32H84c-12 0-16-4-16-16z",
    style: {
      fill: "#fff",
      fillOpacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_MicrosoftExcel__paint0_linear_2256_17069",
    x1: 64,
    x2: 64,
    y1: 16,
    y2: 112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_MicrosoftExcel__paint1_linear_2256_17069",
    x1: 64,
    x2: 64,
    y1: 16,
    y2: 112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_MicrosoftExcel__paint5_linear_2256_17069",
    x1: 47.555,
    x2: 60.91,
    y1: 68.04,
    y2: 91.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F",
    style: _defineProperty(_defineProperty({
      stopColor: "#18884f"
    }, "stopColor", "color(display-p3 .0941 .5333 .3098)"), "stopOpacity", 1)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43",
    style: _defineProperty(_defineProperty({
      stopColor: "#117e43"
    }, "stopColor", "color(display-p3 .0667 .4941 .2627)"), "stopOpacity", 1)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631",
    style: _defineProperty(_defineProperty({
      stopColor: "#0b6631"
    }, "stopColor", "color(display-p3 .0431 .4 .1922)"), "stopOpacity", 1)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_MicrosoftExcel__paint6_linear_2256_17069",
    x1: 84,
    x2: 71.5,
    y1: 31,
    y2: 44.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg_icon_MicrosoftExcel__paint2_radial_2256_17069",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 34 -29.1429 0 85.5 34)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg_icon_MicrosoftExcel__paint3_radial_2256_17069",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-9.00012 20.49993 -23.02097 -10.10694 87.5 33.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg_icon_MicrosoftExcel__paint4_radial_2256_17069",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(135 38.494 32.933)scale(27.5772 18.3848)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "svg_icon_MicrosoftExcel__filter0_dd_2256_17069",
    width: 88,
    height: 112,
    x: 20,
    y: 16,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2256_17069"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2256_17069",
    result: "effect2_dropShadow_2256_17069"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_2256_17069",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMicrosoftExcel);
export { ForwardRef as ReactComponent };